import React, { useRef } from 'react';
import { SliderInput } from '@meitu/saas-ui';
import LabelAction from '@meitu/saas-editor-ui/es/components/label-action';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';

export const OpacityFeature: React.FC<{
    id: string;
    opacity: number;
}> = React.memo(({ id, opacity }) => {
    const { $t } = useLocaleStore();
    const originOpacity = useRef<number | null>(null);

    return (
        <div className="c-qrcode-panel__item opacity  blod">
            <LabelAction title={$t((v) => v.panel.qrCodePanel.opacity)} align={true}>
                <SliderInput
                    value={+(opacity * 100).toFixed(0)}
                    max={100}
                    min={0}
                    showStepBtn={true}
                    type="horizontal"
                    onChange={(val: number) => {
                        val = val / 100;
                        if (originOpacity.current === null) {
                            originOpacity.current = opacity;
                        }
                        editor.qrCodeLayer.setOpacity(id, val);
                    }}
                    onAfterChange={(val: number) => {
                        val = val / 100;
                        editor.qrCodeLayer.setOpacity(id, val, originOpacity.current);
                        originOpacity.current = null;
                    }}
                />
            </LabelAction>
        </div>
    );
});
